<template>
    <div class="footer__slogan">
        <span class="line"></span>
        <h4>Your Routine with {{ appName }}</h4>
    </div>
</template>

<script>
import config from "@/config";
export default {
    data() {
        return {
            appName: config.appName,
        };
    },
}
</script>
